import React, { FC } from 'react';
import { Checkbox, CheckboxGroup, Radio, RadioGroup, Stack, VStack } from '@chakra-ui/react';
import { AnswerType, Question } from '../types';
import TextLabel from '../../Misc/LText';

interface MultipleQuestionProps {
  question: Question;
  onChange: (value: string | string[], question: Question) => void;
}

const MultipleQuestion: FC<MultipleQuestionProps> = ({
  question,
  onChange,
}) => {

  const handleRadioChange = (value: string) => {
    onChange(value, question);
  };

  const handleCheckboxChange = (value: string[]) => {
    onChange(value, question);
  };

  return (
    <VStack width='full' align='start'>
      <TextLabel title={question.value} />

      {question.answerType === AnswerType.SINGLE && (
        question.answerOptions.map((option) => (
          <RadioGroup
            key={option}
            colorScheme='brand'
            value={question.response as string}
            onChange={handleRadioChange}
          >
            <Stack direction='column'>
              <Radio value={option}>{option}</Radio>
            </Stack>
          </RadioGroup>
        ))
      )}

      {question.answerType === AnswerType.MULTIPLE && (
        question.answerOptions.map((option) => (
          <CheckboxGroup
            key={option}
            colorScheme='brand'
            value={question.response as string[]}
            onChange={handleCheckboxChange}
          >
            <Stack direction='column'>
              <Checkbox value={option}>{option}</Checkbox>
            </Stack>
          </CheckboxGroup>
        ))
      )}
    </VStack>
  );
};

export default MultipleQuestion;
